// extracted by mini-css-extract-plugin
export default {"wrapper":"CaptureVisa_style_wrapper__2RJ9-","rotate":"CaptureVisa_style_rotate__0BT1G"};